import { render, staticRenderFns } from "./view-taxonomy.vue?vue&type=template&id=b54e47c0&"
import script from "./view-taxonomy.vue?vue&type=script&lang=js&"
export * from "./view-taxonomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports